////////////////////////////////////////////
//
// Font Awesome
//
////////////////////////////////////////////


import { dom, library } from '@fortawesome/fontawesome-svg-core'

import { 
    faEnvelope as faEnvelope,
    faHeart as faHeart,
    faSearch as faSearch,
} from '@fortawesome/free-solid-svg-icons'

import { 
    faFacebook as faFacebook,
    faTwitter as faTwitter,
    faBitbucket as faBitbucket,
    faGithub as faGithub,
} from '@fortawesome/free-brands-svg-icons'


library.add(faEnvelope,faFacebook,faTwitter,faBitbucket,faGithub,faHeart,faSearch)

// This will convery i to svg
dom.i2svg()

// This will watch for changes
// dom.watch()



// Adding all by prefix
// import { library } from '@fortawesome/fontawesome-svg-core'
// import { fas } from '@fortawesome/free-solid-svg-icons'
// import { far } from '@fortawesome/free-regular-svg-icons'
// import { fab } from '@fortawesome/free-brands-svg-icons'

// Add all icons to the library so you can use it in your page
// library.add(fas, far, fab)

// Use this for multiple versions
// import { faCircle as fasFaCircle } from '@fortawesome/free-solid-svg-icons'
// import { faCircle as farFaCircle } from '@fortawesome/free-regular-svg-icons'
// library.add(fasFaCircle, farFaCircle)


// dom.watch({
//     autoReplaceSvgRoot: document,
//     observeMutationsRoot: document.body
// });